import classNames from 'classnames';

import { Icon, useTranslation } from '@testsigma/atoms';

import { TestCase } from '@modules/test-development/models/test-case.model';

import { LinkedEntitiesList } from '../delete/linked-entities-list';
import { DeleteConnectionModalHeader } from '../delete/header';

interface LinkedEntitiesConnectionScreenProps {
  linkedTestCases: TestCase[];
  linkedStepGroups: TestCase[];
  handleCancel(): void;
  reload(): void;
}

const LinkedEntitiesConnectionScreen: React.FC<
  LinkedEntitiesConnectionScreenProps
> = (props: LinkedEntitiesConnectionScreenProps) => {
  const { linkedTestCases, linkedStepGroups, handleCancel, reload } = props;

  const { t } = useTranslation();

  return (
    <div className={classNames('flex gap-x-6 flex-col')}>
      <DeleteConnectionModalHeader />

      <div className='flex-1'>
        <div style={{ top: '18px', right: '18px' }} className='absolute flex'>
          <Icon
            name='replay'
            onClick={reload}
            className='cursor-pointer text-[20px] mr-4 text-secondary-500'
          />
          <Icon
            name='close'
            onClick={handleCancel}
            className='cursor-pointer text-[24px] text-secondary-500'
          />
        </div>

        <div className='flex flex-col'>
          <div className='text-lg leading-7 font-semibold text-unique-600 pb-3 pt-6'>
            {t('connection_deletion_title')}
          </div>
          <div
            className='text-small leading-5 text-unique-800 pb-6'
            dangerouslySetInnerHTML={{
              __html: t('connection_deletion_note'),
            }}></div>
          <div className='mt-6'>
            <LinkedEntitiesList
              data={linkedTestCases}
              label={'Test Cases'}
              entityType={'TestCase'}
            />
          </div>
          <div className='mt-6'>
            <LinkedEntitiesList
              data={linkedStepGroups}
              label={'Step Groups'}
              entityType={'StepGroup'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { LinkedEntitiesConnectionScreen };
